import React from 'react'
import { cn } from '@s4l/utility-css'
import styles from './index.module.css'

interface SeparatorProps {
  orientation?: 'horizontal' | 'vertical'
  size?: 'small' | 'medium' | 'large'
  color?: string
  className?: string
  style?: React.CSSProperties
  children?: React.ReactNode
}

export default function Separator({
  orientation = 'horizontal',
  size = 'medium',
  color = 'var(--color-neutral-400)',
  className,
  style,
  children,
  ...rest
}: Readonly<SeparatorProps>) {
  if (!children) {
    return (
      <hr
        className={cn(styles.separator, styles[orientation], className)}
        data-size={size}
        style={{ backgroundColor: color, ...style }}
        {...rest}
      />
    )
  }

  return (
    <div
      className={cn(styles.labeledSeparator, styles[orientation], className)}
      style={style}
      {...rest}
    >
      <hr
        className={cn(styles.separator, styles.line)}
        data-size={size}
        style={{ backgroundColor: color }}
      />
      {children ? <div className={styles.content}>{children}</div> : null}
      <hr
        className={cn(styles.separator, styles.line)}
        data-size={size}
        style={{ backgroundColor: color }}
      />
    </div>
  )
}
